
import { PagedMessageResponse } from "app/api/types/PagedMessageResponse";
import { Paginacao } from "app/components/itens-orcamento/paginacao/Paginacao";
import { Parametro } from "app/types/Parametro";
import { DadosDaPesquisaOrcamento } from "app/types/pesquisa-orcamento/PesquisaOrcamento";
import { DadoHistoricoOrcamento } from "app/types/pesquisa-orcamento/consultas/Historico";
import globalMU from "globalMU";
import React, { useMemo } from "react";

const estilosTabelas = require('../../../estilos/tabelas.module.scss').default
const parametroFonteReceita = "UTILIZA_RELACIONAMENTO_FILIAL_VENDEDOR_FONTE_RECEITA";
const espacoFinalStyle = { marginBottom: "100px" };

export type HistoricoOrcamentoProps = {
    orcamentoSelecionado: Partial<DadosDaPesquisaOrcamento>
    historicos: Partial<PagedMessageResponse<DadoHistoricoOrcamento>>
    parametros?: Parametro[] // 487678
    onPesquisarPaginado: (pagina: number) => void
}

export const HistoricoOrcamento = React.memo((props: HistoricoOrcamentoProps) => {

    const exibirFonteReceita = useMemo(() =>
        props.parametros?.some((p) => p.Nome == parametroFonteReceita && p.Valor == "S") ?? false,
        [props.parametros]
    ); // 487678

    const dataPedido = useMemo(() =>
        globalMU.formatDate(props.orcamentoSelecionado.DataPedido),
        [props.orcamentoSelecionado.DataPedido]
    );

    const valorPedido = useMemo(() =>
        globalMU.formatarValorNumerico(props.orcamentoSelecionado.ValorPedido, 2, true),
        [props.orcamentoSelecionado.ValorPedido]
    );

    const cabecalho = useMemo(() => (
        <div className="_my-2"
            id="HistoricoOrcamento_Cabecalho"
        >
            <div className="_flex _items-center">
                <label className="_w-[190px] _bg-[#e4e6e8] _text-right _font-normal _mb-0 _p-2">Filial</label>
                <p className="_mb-0 _p-2"
                    id="HistoricoOrcamento_Filial"
                >{props.orcamentoSelecionado.Filial}</p>
            </div>
            <div className="_flex _items-center">
                <label className="_w-[190px] _bg-[#e4e6e8] _text-right _font-normal _mb-0 _p-2">Nº Orçamento</label>
                <p className="_mb-0 _p-2"
                    id="HistoricoOrcamento_NumeroPedido"
                >{props.orcamentoSelecionado.NumeroPedido}</p>
            </div>
            <div className="_flex _items-center">
                <label className="_w-[190px] _bg-[#e4e6e8] _text-right _font-normal _mb-0 _p-2">CLiente</label>
                <p className="_mb-0 _p-2"
                    id="HistoricoOrcamento_RazaoSocialCliente"
                >{props.orcamentoSelecionado.RazaoSocialCliente}</p>
            </div>
            <div className="_flex _items-center">
                <label className="_w-[190px] _bg-[#e4e6e8] _text-right _font-normal _mb-0 _p-2">Vendedor</label>
                <p className="_mb-0 _p-2">{props.orcamentoSelecionado.Vendedor}</p>
            </div>
            <div className="_flex _items-center">
                <label className="_w-[190px] _bg-[#e4e6e8] _text-right _font-normal _mb-0 _p-2">Data</label>
                <p className="_mb-0 _p-2"
                    id="HistoricoOrcamento_DataPedido"
                >{dataPedido}</p>
            </div>
            <div className="_flex _items-center">
                <label className="_w-[190px] _bg-[#e4e6e8] _text-right _font-normal _mb-0 _p-2">Valor</label>
                <p className="_mb-0 _p-2"
                    id="HistoricoOrcamento_ValorPedido"
                >{valorPedido}</p>
            </div>
            {exibirFonteReceita && // 487678
            <div className="_flex _items-center">
                <label className="_w-[190px] _bg-[#e4e6e8] _text-right _font-normal _mb-0 _p-2"
                    title="Veja parâmetro: Utiliza relacionamento de filial e vendedor por fonte de receita?"
                >Fonte de Receita</label>
                <p className="_mb-0 _p-2"
                    id="HistoricoOrcamento_FonteReceita"
                >{props.orcamentoSelecionado.FonteDeReceita}</p>
            </div>
            }
        </div>
    ), [
        dataPedido,
        exibirFonteReceita,
        props.orcamentoSelecionado.Filial,
        props.orcamentoSelecionado.FonteDeReceita,
        props.orcamentoSelecionado.NumeroPedido,
        props.orcamentoSelecionado.RazaoSocialCliente,
        props.orcamentoSelecionado.Vendedor,
        valorPedido,
    ]);

    const linhasHistorico = useMemo(() => props.historicos?.Entities?.map((historico, index) => {
        return (
            <tr className="_cursor-pointer hover:_bg-white"
                id={`HistoricoOrcamento_Tabela_Corpo_Linha_${index}`}
                key={`${historico.Data}_${historico.Usuario}_${index}`}
            >
                <td className="_bg-[#b9b9b9]"
                    id={`HistoricoOrcamento_Tabela_Corpo_Linha_${index}_Data`}
                >{globalMU.formatDateTime(historico.Data)}</td>
                <td className="_bg-[#b9b9b9]"
                    id={`HistoricoOrcamento_Tabela_Corpo_Linha_${index}_Usuario`}
                >{historico.Usuario}</td>
                <td className="_bg-[#b9b9b9]"
                    id={`HistoricoOrcamento_Tabela_Corpo_Linha_${index}_UsuarioLiberacao`}
                >{historico.UsuarioLiberacao}</td>
                <td className="_bg-[#b9b9b9]"
                    id={`HistoricoOrcamento_Tabela_Corpo_Linha_${index}_SituacaoVenda`}
                >{historico.SituacaoVenda}</td>
                <td
                    id={`HistoricoOrcamento_Tabela_Corpo_Linha_${index}_SitConferencia`}
                >{historico.SituacaoConferencia}</td>
                <td
                    id={`HistoricoOrcamento_Tabela_Corpo_Linha_${index}_Historico`}
                >{historico.Historico}</td>
            </tr>
        );
    }), [props.historicos?.Entities]);

    const tabela = useMemo(() => (
        <div className="_my-2">
            <table className={`_table _w-full _border-collapse ${estilosTabelas.tabela}`}
                id="HistoricoOrcamento_Tabela"
            >
                <thead
                    id="HistoricoOrcamento_Tabela_Cabecalho"
                >
                    <tr
                        id="HistoricoOrcamento_Tabela_Cabecalho_Linha"
                    >
                        <th
                            id="HistoricoOrcamento_Tabela_Cabecalho_Linha_Data"
                        >Data/Hora</th>
                        <th
                            id="HistoricoOrcamento_Tabela_Cabecalho_Linha_Usuario"
                        >Usuário</th>
                        <th
                            id="HistoricoOrcamento_Tabela_Cabecalho_Linha_UsuarioLiberacao"
                        >Usuário Liberação</th>
                        <th
                            id="HistoricoOrcamento_Tabela_Cabecalho_Linha_SituacaoVenda"
                        >Situacão da Venda</th>
                        <th 
                            id="HistoricoOrcamento_Tabela_Cabecalho_Linha_SituacaoConferencia"
                        >Situacão de Conferência</th>
                        <th
                            id="HistoricoOrcamento_Tabela_Cabecalho_Linha_Historico"
                        >Histórico</th>
                    </tr>
                </thead>
                <tbody
                    id="HistoricoOrcamento_Tabela_Corpo"
                >
                    {linhasHistorico}
                </tbody>
            </table>
        </div>
    ), [linhasHistorico]);

    return (
        <>
            {cabecalho}

            {tabela}

            {props.historicos?.PageCount > 1 &&
                <Paginacao
                    id="HistoricoOrcamento_Paginacao"
                    paginaAtual={props.historicos?.ActualPage}
                    totalPaginas={props.historicos?.PageCount}
                    onAlterarListaSelecionada={props.onPesquisarPaginado}
                />
            }
            {<section style={espacoFinalStyle} />}
        </>
    )

})
